<template>
  <page-header-wrapper><a-card title="认证会员折扣配置" :bordered="false">
    <a-alert message="填写额外优惠百分比：10 表示优惠10%（单独使用为九折），0 表示关闭认证优惠。与商品活动优惠按现有规则叠加，总优惠最多100%；不会重算已有订单的保存金额。" type="info" show-icon style="margin-bottom:24px" />
    <a-spin :spinning="loading"><a-form layout="vertical"><a-form-item label="认证会员额外优惠（%）"><a-input-number v-model="rate" :min="0" :max="100" :precision="2" :disabled="!loaded || saving" style="width:220px" /></a-form-item>
    <p>仅计算认证优惠：¥100 → ¥{{ preview }}</p>
    <a-button type="primary" v-hasPermi="['dkmall:certified-discount:edit']" :disabled="!loaded || loading" :loading="saving" @click="save">保存认证会员折扣</a-button>
    <a-button style="margin-left:12px" :disabled="saving" @click="load">刷新</a-button></a-form></a-spin>
  </a-card></page-header-wrapper>
</template>
<script>
import request from '@/utils/request'
const url='/dkmall/config/certified-discount'
export default {
 name:'CertifiedDiscount',data:()=>({rate:null,loaded:false,loading:false,saving:false}),
 computed:{preview(){return this.rate==null?'—':(100-Number(this.rate)).toFixed(2)}},
 created(){this.load()},
 methods:{
  load(){this.loading=true;this.loaded=false;return request({url,method:'get'}).then(response=>{this.rate=Number(response.data.rate);this.loaded=true}).finally(()=>{this.loading=false})},
  save(){if(!this.loaded||this.saving||this.rate==null||!Number.isFinite(Number(this.rate))||this.rate<0||this.rate>100)return;const rate=String(this.rate);return this.$confirm({title:`确认将认证会员额外优惠设为 ${rate}%？`,content:'新计算的商品价格与订单将采用此比例，已有订单金额不变。',onOk:()=>{this.saving=true;return request({url,method:'put',data:{rate}}).then(()=>this.$message.success('认证会员折扣已保存')).finally(()=>{this.saving=false})}})}
 }
}
</script>
